import script from "./CScrollbar.vue?vue&type=script&lang=js"
export * from "./CScrollbar.vue?vue&type=script&lang=js"

import "perfect-scrollbar/css/perfect-scrollbar.css?vue&type=style&index=0&id=1d93d670&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d93d670"]])

export default __exports__